/* eslint-disable react/sort-comp */
import Translator from '../../../../utils/translation/Translator';
import { Flexbox, NotValidatedInput } from '@idm/ui-components';
import './styleBarGroup.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

class SearchBarGroup extends Component {
  static propTypes = {
    searchFilters: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
    fetchSearchResults: PropTypes.func.isRequired,
    totalCount: PropTypes.number,
    dictionary: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  };

  timeoutId = null;

  timeoutInMs = 500;

  static defaultProps = {
    totalCount: 0,
  };

  constructor(props) {
    super(props);

    this.state = {
      currentSearchFilter: '',
    };
  }

  handleInputChange = (event, filterName) => {
    const searchPhrase = event.target.value;

    this.setState({
      [filterName]: searchPhrase,
    });

    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(() => {
      this.props.fetchSearchResults(searchPhrase);
    }, this.timeoutInMs);
  };

  renderSearchBar = (searchFilter) => {
    const { name: filterName } = searchFilter;
    const switchClientDictionary = new Translator('ACCOUNT_SETTINGS.SWITCH_CLIENT');
    const { dictionary } = this.props;

    return (
      <div className="search-bar" key={searchFilter.name}>
        <NotValidatedInput
          autoComplete="off"
          value={this.state[filterName]}
          onChange={(e) => this.handleInputChange(e, filterName)}
          placeholder={switchClientDictionary.get('SEARCH_PLACEHOLDER', dictionary)}
          label={switchClientDictionary.get('SEARCH_FILTER_CLIENT_NAME', dictionary)}
          addonIconName="fa-search"
        />
      </div>
    );
  };

  render() {
    const { searchFilters, totalCount, dictionary } = this.props;
    const switchClientDictionary = new Translator('ACCOUNT_SETTINGS.SWITCH_CLIENT');

    return (
      <Flexbox className="search-flex">
        {searchFilters.map((searchFilter) => this.renderSearchBar(searchFilter))}
        <div>
          {switchClientDictionary.get('TOTAL_COUNT', dictionary)} {totalCount}
        </div>
      </Flexbox>
    );
  }
}

export default SearchBarGroup;
